import { render, staticRenderFns } from "./ElectronMenu.vue?vue&type=template&id=6ac21d74&scoped=true"
import script from "./ElectronMenu.vue?vue&type=script&lang=js"
export * from "./ElectronMenu.vue?vue&type=script&lang=js"
import style0 from "./ElectronMenu.vue?vue&type=style&index=0&id=6ac21d74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac21d74",
  null
  
)

export default component.exports